import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration
import { showDocumentFile } from 'helpers/registeredDocumentFile'; // Shared "Visualizar archivo" window

/**
 * Class representing the record table deposit report view.
 * @extends JetView
 */
export default class recordTableDepositReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const vthis = this; // Keeps the document Id and Name received in version:id

        // Actions column for both version tables (new object each time, Webix mutates column configs): view the file of each version.
        // Its only icon depends on the permission, so without it the column is not added
        const actionsColumns = () =>
            devConfig.getPermAction('registeredDocumentViewVersion', 'Add') ? [actionsColumn()] : [];
        const actionsColumn = () => ({
            id: 'actions',
            header: _('Acciones'),
            width: 90,
            tooltip: false, // Each icon has its own webix_tooltip
            template: function () {
                return (
                    "<span webix_tooltip='" +
                    _('Visualizar archivo') +
                    "' class='webix_icon wxi-file icon-file-text viewVersionFile prm-registeredDocumentViewVersion' style='cursor:pointer;'></span>"
                );
            },
        });

        // Same resource as the main table: Id of the document from version:id and Version of the clicked row
        const versionClick = {
            viewVersionFile: function (e, id) {
                const row = this.getItem(id.row);
                showDocumentFile(
                    { Id: vthis.documentId, Version: row.Version, Name: vthis.documentName },
                    _,
                    devConfig.getPermAction('registeredDocumentDownload', 'Add'),
                    true, // Download audit
                );
            },
        };

        // Window for advanced filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails', // Data table for details, synced with versionTable in init
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                tooltip: true, // Enables the webix_tooltip of the action icons
                onClick: versionClick,
                columns: [
                    ...actionsColumns(),
                    {
                        id: 'Version',
                        header: _('Versión'), // Version header
                        width: 150,
                        sort: 'int', // Sort by integer
                    },
                    {
                        id: 'DocumentUrl',
                        header: _('Url documento'), // Document URL header
                        width: 400,
                        sort: 'int',
                    },
                    {
                        id: 'EncryptionValue',
                        header: _('Encriptación'), // Encryption header
                        width: 250,
                        sort: 'int',
                    },
                    {
                        id: 'CreatedDate',
                        header: _('Fecha de creación'), // Creation date header
                        width: 150,
                        sort: 'int',
                    },
                ],
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            id: 'versionTable', // Main data table ID
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            tooltip: true, // Enables the webix_tooltip of the action icons
            onClick: versionClick,
            columns: [
                ...actionsColumns(),
                {
                    id: 'Version',
                    header: _('Versión'), // Version header
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'DocumentUrl',
                    header: _('Url documento'), // Document URL header
                    width: 400,
                    sort: 'int',
                },
                {
                    id: 'EncryptionValue',
                    header: _('Encriptación'), // Encryption header
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'CreatedDate',
                    header: _('Fecha de creación'), // Creation date header
                    width: 150,
                    sort: 'int',
                },
            ],
            pager: 'pagerV', // Pager for the data table
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'es/RegisteredDocument/GetVersion'; // API URL for fetching versions
        $$('dtDetails').sync(grid); // Details table reuses this data, so GetVersion is requested only once
        this.on(this.app, 'version:id', (Id, Name) => {
            this.documentId = Id; // Kept for the view file action of each version
            this.documentName = Name;
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?id=' + Id); // Load new data based on the ID
        });
        // Version added from the edit popup: reload only if this table shows that document
        this.on(this.app, 'registeredDocument:versionAdded', (Id) => {
            if (this.documentId !== undefined && String(this.documentId) === String(Id)) {
                grid.clearAll();
                grid.load(url + '?id=' + Id);
            }
        });
    }
}

// FILE DOCUMENTED
